export default [
  {
    path: '/index',
    name: 'Index',
    component: () => import('./Index.vue'),
    meta: {title: '首页', affix: true}
  },
]
